import { Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function SparklesIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M10.09 14.552a4.545 4.545 0 0 0-4.545 4.546A4.545 4.545 0 0 0 1 14.552a4.545 4.545 0 0 0 4.546-4.545 4.545 4.545 0 0 0 4.545 4.545ZM18.817 7.364a6.363 6.363 0 0 0-6.363 6.363 6.363 6.363 0 0 0-6.363-6.363h.001A6.363 6.363 0 0 0 12.455 1a6.363 6.363 0 0 0 6.363 6.364Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
    </Icon>
  );
}
